// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * @Author: Yoney Y (YuTianyuan)
 * @Date: 2021-12-10 13:44:27
 * @Last Modified by: undefined (ZhangZeHao)
 * @Last Modified time: 2022-04-27 10:50:38
 */
.flex {
  display: flex;
}
.flex-shrink {
  flex-shrink: 0;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-direction-row {
  flex-direction: row;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-align-items-center {
  align-items: center;
}
.flex-align-items-start {
  align-items: flex-start;
}
.flex-align-items-end {
  align-items: flex-end;
}
.flex-align-self-start {
  align-self: flex-start;
}
.flex-align-self-end {
  align-self: flex-end;
}
.flex-align-self-center {
  align-self: center;
}
.flex-align-self-baseline {
  align-self: baseline;
}
.flex-justify-content-center {
  justify-content: center;
}
.flex-justify-content-start {
  justify-content: flex-start;
}
.flex-justify-content-end {
  justify-content: flex-end;
}
.flex-justify-content-space-between {
  justify-content: space-between;
}
.flex-justify-content-space-around {
  justify-content: space-around;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
.flex-7 {
  flex: 7;
}
.flex-8 {
  flex: 8;
}
.flex-9 {
  flex: 9;
}
.flex-10 {
  flex: 10;
}
.flex-11 {
  flex: 11;
}
.flex-12 {
  flex: 12;
}
.flex-13 {
  flex: 13;
}
.flex-14 {
  flex: 14;
}
.flex-15 {
  flex: 15;
}
.flex-16 {
  flex: 16;
}
.flex-17 {
  flex: 17;
}
.flex-18 {
  flex: 18;
}
.flex-19 {
  flex: 19;
}
.flex-20 {
  flex: 20;
}
.flex-21 {
  flex: 21;
}
.flex-22 {
  flex: 22;
}
.flex-23 {
  flex: 23;
}
.flex-24 {
  flex: 24;
}
.odd-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
:root {
  --theme-main-color: #3A7FFF;
  --theme-comm-color: #5B9DFF;
  --theme-bg-color: #F2F3F7;
  --theme-main-bg-color: #FFFFFF;
  --theme-text-color: #000;
  --theme-title-color: #333;
  --theme-active-color: #448FF7;
  --theme-button-color: #448FF7;
  --theme-primary-hover: #2F6FE6;
  --theme-menu-bg: linear-gradient(180deg, #0a2f6e 0%, #1247a8 45%, #1a5fd0 100%);
  --theme-menu-border: rgba(255, 255, 255, 0.08);
  --theme-menu-text: rgba(255, 255, 255, 0.78);
  --theme-menu-text-active: #ffffff;
  --theme-menu-hover-bg: rgba(255, 255, 255, 0.14);
  --theme-menu-active-bg: rgba(255, 255, 255, 0.22);
  --theme-content-bg: #e9eef5;
  --theme-content-surface: #ffffff;
  --theme-content-border: #e4eaf2;
  --theme-content-muted: #64748b;
  --theme-filter-bg: linear-gradient(135deg, #dfeaff 0%, #ebf3ff 52%, #f5f9ff 100%);
  --theme-filter-border: rgba(58, 127, 255, 0.28);
  --theme-filter-accent: #3A7FFF;
  --theme-shell-header-bg: linear-gradient(90deg, #0f2f6e 0%, #1d4ed8 52%, #2563eb 100%);
  --theme-padding: 20px;
}
/* 列表页 / 弹窗内搜索区统一样式 */
#Home .znrunpay-home-content .list-filter,
.ant-modal .list-filter,
.list-filter {
  padding: 18px 18px 6px;
  background: var(--theme-filter-bg);
  border: 1px solid var(--theme-filter-border);
  border-left: 4px solid var(--theme-filter-accent);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(58, 127, 255, 0.1);
}
#Home .znrunpay-home-content .list-filter .ant-form-item-label > label,
.ant-modal .list-filter .ant-form-item-label > label,
.list-filter .ant-form-item-label > label {
  color: #475569;
  font-weight: 500;
}
#Home .znrunpay-home-content .list-filter {
  margin: 16px 16px 0;
}
.ant-modal .list-filter {
  margin-bottom: 16px;
}
/* 后台管理手机端适配：侧栏抽屉、弹窗铺满、表格横滑、表单竖排 */
html {
  -webkit-text-size-adjust: 100%;
}
@media (max-width: 767px) {
  input,
  textarea,
  select,
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  .ant-picker {
    font-size: 16px !important;
  }
  /* —— 布局：内容占满，侧栏改抽屉 —— */
  #Home {
    display: flex;
    flex-direction: column;
  }
  #Home .znrunpay-home-header-wrap {
    position: relative;
    z-index: 1300;
    flex-shrink: 0;
  }
  #Home .znrunpay-home-main {
    flex: 1;
    min-height: 0;
    height: auto !important;
    width: 100%;
  }
  #Home .znrunpay-home-layout-left {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: min(82vw, 300px) !important;
    padding-top: 52px;
    z-index: 1200;
    overflow: auto;
  }
  #Home .znrunpay-home-layout-right,
  #Home .layout-menu-show,
  #Home .layout-right-hidden {
    width: 100% !important;
    padding: 6px 6px 0;
  }
  #Home .znrunpay-home-content {
    height: 100%;
    border-radius: 8px 8px 0 0;
  }
  #Home .znrunpay-home-content .ant-layout {
    padding: 8px 10px !important;
  }
  #Home .znrunpay-home-content .list-table {
    margin: 8px 6px 12px;
    padding: 8px;
    overflow-x: auto;
  }
  .znrunpay-menu-mask {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.48);
    z-index: 1100;
  }
  .znrunpay-menu {
    height: calc(100vh - 60px);
  }
  .znrunpay-menu .znrun-menu-item {
    min-height: 44px;
    padding: 12px;
  }
  .znrunpay-menu .znrunpay-menu-right-con {
    min-height: 40px;
    display: flex;
    align-items: center;
  }
  /* —— 顶栏 —— */
  .znrunpay-home-header {
    height: 52px;
    padding: 0 6px;
    gap: 6px;
  }
  .znrunpay-home-header .znrunpay-header-left {
    min-width: 0;
    padding: 0 4px;
  }
  .znrunpay-home-header .znrunpay-header-left .znrunpay-brand-title {
    font-size: 16px;
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .znrunpay-home-header .menu-button {
    padding: 0 !important;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .znrunpay-home-header .znrunpay-header-missing-track {
    min-width: 0;
    max-width: none;
    margin: 0 4px;
    padding: 4px 8px;
    gap: 6px;
  }
  .znrunpay-home-header .znrunpay-header-missing-track .znrunpay-header-missing-track-text {
    display: none;
  }
  .znrunpay-home-header .znrunpay-header-layout-right .znrunpay-account-switch {
    margin-right: 6px;
  }
  .znrunpay-home-header .znrunpay-header-layout-right .znrunpay-account-switch .ant-select {
    width: 112px !important;
  }
  .znrunpay-home-header .znrunpay-header-layout-right .znrunpay-user-profile {
    margin: 0 0 0 4px;
    padding: 2px 6px;
  }
  .znrunpay-home-header .znrunpay-header-layout-right .znrunpay-user-profile .znrunpay-user-profile-name {
    display: none;
  }
  .znrunpay-home-header .znrunpay-header-layout-right .znrunpay-user-down {
    display: none;
  }
  .znrunpay-impersonate-banner-inner {
    flex-wrap: wrap;
    gap: 8px;
  }
  /* —— 筛选区：标签在上、控件铺满 —— */
  .list-filter {
    padding: 12px 12px 2px !important;
    margin: 8px 6px 0 !important;
  }
  .list-filter .ant-form-item {
    margin-bottom: 10px;
  }
  .list-filter .ant-form-item .ant-form-item-row {
    flex-direction: column;
    align-items: stretch;
  }
  .list-filter .ant-form-item-label {
    text-align: left !important;
    padding: 0 0 4px !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .list-filter .ant-form-item-label > label {
    height: auto;
  }
  .list-filter .ant-form-item-control {
    max-width: 100% !important;
    width: 100% !important;
  }
  .list-filter .znrunpay-order-search .ant-form-item-control-input-content {
    display: flex;
    gap: 8px;
  }
  .list-filter .znrunpay-order-search .ant-form-item-control-input-content .ant-btn {
    flex: 1;
    height: 40px;
  }
  .znrunpay-total-button {
    flex-wrap: wrap;
    gap: 8px;
  }
  .znrunpay-total-button .znrunpay-table-setup {
    margin-left: 0;
    width: 100%;
  }
  .znrunpay-total-button .znrunpay-table-setup .ant-space {
    width: 100%;
    flex-wrap: wrap;
  }
  .znrunpay-total-button .znrunpay-table-setup .ant-btn {
    min-height: 40px;
  }
  /* —— 表格：横滑 + 更大点击区域 —— */
  .ant-table-wrapper,
  .ant-table-content,
  .ant-table-container {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .ant-table {
    min-width: 640px;
  }
  .ant-table .ant-table-thead > tr > th,
  .ant-table .ant-table-tbody > tr > td {
    padding: 8px 10px !important;
    white-space: nowrap;
  }
  .ant-table .ant-table col:last-child {
    width: 96px !important;
  }
  .ant-table .ant-table-thead > tr > th:last-child,
  .ant-table .ant-table-tbody > tr > td:last-child {
    position: sticky;
    right: 0;
    z-index: 3;
    background: #fff;
    white-space: normal !important;
    box-shadow: -6px 0 10px rgba(15, 23, 42, 0.08);
  }
  .ant-table .ant-table-tbody > tr > td:has(.ant-btn) {
    white-space: normal;
  }
  .ant-table .ant-btn-link {
    min-height: 36px;
    padding: 6px 8px !important;
    font-size: 14px;
  }
  .ant-table .ant-space {
    flex-wrap: wrap;
  }
  .ant-pagination {
    flex-wrap: wrap !important;
    justify-content: flex-start !important;
    row-gap: 8px;
  }
  .ant-pagination .ant-pagination-options-quick-jumper {
    display: none;
  }
  /* —— 弹窗：铺满可视区域，表单竖排 —— */
  .ant-modal {
    max-width: calc(100vw - 12px) !important;
    width: calc(100vw - 12px) !important;
    margin: 8px auto !important;
    padding-bottom: 0;
    top: 8px !important;
  }
  .ant-modal-centered .ant-modal {
    top: 0 !important;
  }
  .ant-modal-content {
    max-height: calc(100vh - 16px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .ant-modal-body {
    overflow-y: auto;
    max-height: calc(100vh - 150px);
    padding: 12px !important;
  }
  .ant-modal .ant-col,
  .znrunpay-Distribution-confirm .ant-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-inline-start: 0 !important;
  }
  .ant-modal .ant-form-item .ant-form-item-row,
  .znrunpay-Distribution-confirm .ant-form-item .ant-form-item-row {
    flex-direction: column;
    align-items: stretch;
  }
  .ant-modal .ant-form-item-label,
  .znrunpay-Distribution-confirm .ant-form-item-label {
    text-align: left !important;
    max-width: 100% !important;
    width: 100% !important;
    padding-bottom: 4px;
  }
  .ant-modal .ant-form-item-control,
  .znrunpay-Distribution-confirm .ant-form-item-control {
    max-width: 100% !important;
    width: 100% !important;
  }
  .ant-modal .ant-select,
  .ant-modal .ant-picker,
  .znrunpay-Distribution-confirm .ant-select,
  .znrunpay-Distribution-confirm .ant-picker {
    width: 100% !important;
  }
  .ant-modal-confirm-btns,
  .ant-modal-footer {
    display: flex;
    gap: 8px;
  }
  .ant-modal-confirm-btns .ant-btn,
  .ant-modal-footer .ant-btn {
    flex: 1;
    min-height: 40px;
    margin: 0 !important;
  }
  .ant-popover,
  .ant-popconfirm {
    max-width: calc(100vw - 24px);
  }
  .ant-select-dropdown,
  .ant-picker-dropdown,
  .ant-dropdown {
    max-width: calc(100vw - 12px);
  }
  /* —— 登录页 —— */
  #Login .znrunpay-login-right {
    max-width: 100%;
  }
  #Login .znrunpay-login-form-content {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    width: 100% !important;
    padding: 48px 20px 24px;
  }
  #Login .znrunpay-login-logo {
    padding-left: 0;
    justify-content: center;
  }
  #Login .znrunpay-right-text {
    margin-left: 0;
    text-align: center;
  }
  #Login .ant-form-item-control,
  #Login .ant-form-item-label {
    max-width: 100% !important;
    width: 100% !important;
  }
  #Login .znrunpay-right-from-input {
    width: 100%;
  }
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "PingFangSC-Regular", sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, apple color emoji, segoe ui emoji, Segoe UI Symbol, noto color emoji;
  -webkit-tap-highlight-color: transparent;
}
html,
body,
#root,
#App {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
input,
textarea,
button,
video {
  outline: none;
  vertical-align: middle;
  -webkit-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/rest.less","webpack://./src/assets/styles/flex.less","webpack://./src/assets/styles/variable.less","webpack://./src/assets/styles/list-filter.less","webpack://./src/assets/styles/mobile.less"],"names":[],"mappings":"AAAA;;;;;EAKE;ACFF;EACE,aAAA;ADIF;ACDA;EACE,cAAA;ADGF;ACAA;EACE,eAAA;ADEF;ACCA;EACE,mBAAA;ADCF;ACEA;EACE,sBAAA;ADAF;ACGA;EACE,mBAAA;ADDF;ACIA;EACE,uBAAA;ADFF;ACKA;EACE,qBAAA;ADHF;ACMA;EACE,sBAAA;ADJF;ACOA;EACE,oBAAA;ADLF;ACQA;EACE,kBAAA;ADNF;ACSA;EACE,oBAAA;ADPF;ACUA;EACE,uBAAA;ADRF;ACWA;EACE,2BAAA;ADTF;ACYA;EACE,yBAAA;ADVF;ACaA;EACE,8BAAA;ADXF;ACcA;EACE,6BAAA;ADZF;ACgBG;EACC,OAAA;ADdJ;ACaG;EACC,OAAA;ADXJ;ACUG;EACC,OAAA;ADRJ;ACOG;EACC,OAAA;ADLJ;ACIG;EACC,OAAA;ADFJ;ACCG;EACC,OAAA;ADCJ;ACFG;EACC,OAAA;ADIJ;ACLG;EACC,OAAA;ADOJ;ACRG;EACC,OAAA;ADUJ;ACXG;EACC,QAAA;ADaJ;ACdG;EACC,QAAA;ADgBJ;ACjBG;EACC,QAAA;ADmBJ;ACpBG;EACC,QAAA;ADsBJ;ACvBG;EACC,QAAA;ADyBJ;AC1BG;EACC,QAAA;AD4BJ;AC7BG;EACC,QAAA;AD+BJ;AChCG;EACC,QAAA;ADkCJ;ACnCG;EACC,QAAA;ADqCJ;ACtCG;EACC,QAAA;ADwCJ;ACzCG;EACC,QAAA;AD2CJ;AC5CG;EACC,QAAA;AD8CJ;AC/CG;EACC,QAAA;ADiDJ;AClDG;EACC,QAAA;ADoDJ;ACrDG;EACC,QAAA;ADuDJ;AC5CA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AD8CF;AC1CA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;AD4CF;AE3IA;EACE,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;EAEA,6BAAA;EACA,6BAAA;EACA,8BAAA;EACA,+EAAA;EACA,8CAAA;EACA,4CAAA;EACA,iCAAA;EACA,gDAAA;EACA,iDAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,iFAAA;EACA,+CAAA;EACA,8BAAA;EACA,sFAAA;EAEA,qBAAA;AF2IF;AACA,qBAAqB;AGrKrB;;;EAGE,sBAAA;EACA,kCAAA;EACA,4CAAA;EACA,iDAAA;EACA,mBAAA;EACA,8CAAA;AHuKF;AG/KA;;;EAWI,cAAA;EACA,gBAAA;AHyKJ;AGrKA;EACE,mBAAA;AHuKF;AGpKA;EACE,mBAAA;AHsKF;AACA,kCAAkC;AI3LlC;EACE,8BAAA;AJ6LF;AI1LA;EACE;;;;;;;IAOE,0BAAA;EJ4LF;EACA,wBAAwB;EIzLxB;IACE,aAAA;IACA,sBAAA;EJ2LF;EI7LA;IAKI,kBAAA;IACA,aAAA;IACA,cAAA;EJ2LJ;EIlMA;IAWI,OAAA;IACA,aAAA;IACA,uBAAA;IACA,WAAA;EJ0LJ;EIxMA;IAkBI,eAAA;IACA,OAAA;IACA,MAAA;IACA,SAAA;IACA,kCAAA;IACA,iBAAA;IACA,aAAA;IACA,cAAA;EJyLJ;EIlNA;;;IA+BI,sBAAA;IACA,kBAAA;EJwLJ;EIxNA;IAoCI,YAAA;IACA,0BAAA;EJuLJ;EI5NA;IAwCM,4BAAA;EJuLN;EI/NA;IA4CM,oBAAA;IACA,YAAA;IACA,gBAAA;EJsLN;EIjLA;IACE,eAAA;IACA,QAAA;IACA,kCAAA;IACA,aAAA;EJmLF;EIhLA;IACE,0BAAA;EJkLF;EInLA;IAII,gBAAA;IACA,aAAA;EJkLJ;EIvLA;IASI,gBAAA;IACA,aAAA;IACA,mBAAA;EJiLJ;EACA,aAAa;EI7Kb;IACE,YAAA;IACA,cAAA;IACA,QAAA;EJ+KF;EIlLA;IAMI,YAAA;IACA,cAAA;EJ+KJ;EItLA;IAUM,eAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;EJ+KN;EI5LA;IAkBI,qBAAA;IACA,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EJ6KJ;EIpMA;IA2BI,YAAA;IACA,eAAA;IACA,aAAA;IACA,gBAAA;IACA,QAAA;EJ4KJ;EI3MA;IAkCM,aAAA;EJ4KN;EI9MA;IAwCM,iBAAA;EJyKN;EIjNA;IA2CQ,uBAAA;EJyKR;EIpNA;IAgDM,iBAAA;IACA,gBAAA;EJuKN;EIxNA;IAoDQ,aAAA;EJuKR;EI3NA;IAyDM,aAAA;EJqKN;EIhKA;IACE,eAAA;IACA,QAAA;EJkKF;EACA,wBAAwB;EI/JxB;IACE,iCAAA;IACA,4BAAA;EJiKF;EInKA;IAKI,mBAAA;EJiKJ;EItKA;IASI,sBAAA;IACA,oBAAA;EJgKJ;EI1KA;IAcI,2BAAA;IACA,2BAAA;IACA,0BAAA;IACA,sBAAA;EJ+JJ;EIhLA;IAoBM,YAAA;EJ+JN;EInLA;IAyBI,0BAAA;IACA,sBAAA;EJ6JJ;EIvLA;IA8BI,aAAA;IACA,QAAA;EJ4JJ;EI3LA;IAkCM,OAAA;IACA,YAAA;EJ4JN;EIvJA;IACE,eAAA;IACA,QAAA;EJyJF;EI3JA;IAKI,cAAA;IACA,WAAA;EJyJJ;EI/JA;IASM,WAAA;IACA,eAAA;EJyJN;EInKA;IAcM,gBAAA;EJwJN;EACA,yBAAyB;EInJzB;;;IAGE,2BAAA;IACA,iCAAA;EJqJF;EIlJA;IACE,gBAAA;EJoJF;EIrJA;;IAKI,4BAAA;IACA,mBAAA;EJoJJ;EI1JA;IAUI,sBAAA;EJmJJ;EI7JA;;IAeI,gBAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;IACA,8BAAA;IACA,8CAAA;EJkJJ;EItKA;IAwBI,mBAAA;EJiJJ;EIzKA;IA4BI,gBAAA;IACA,2BAAA;IACA,eAAA;EJgJJ;EI9KA;IAkCI,eAAA;EJ+IJ;EI3IA;IACE,0BAAA;IACA,sCAAA;IACA,YAAA;EJ6IF;EIhJA;IAMI,aAAA;EJ6IJ;EACA,yBAAyB;EIzIzB;IACE,wCAAA;IACA,oCAAA;IACA,2BAAA;IACA,iBAAA;IACA,mBAAA;EJ2IF;EIxIA;IACE,iBAAA;EJ0IF;EIvIA;IACE,8BAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;EJyIF;EItIA;IACE,gBAAA;IACA,+BAAA;IACA,wBAAA;EJwIF;EIrIA;;IAEE,yBAAA;IACA,0BAAA;IACA,iCAAA;EJuIF;EIpIA;;IAEE,sBAAA;IACA,oBAAA;EJsIF;EInIA;;IAEE,2BAAA;IACA,0BAAA;IACA,sBAAA;IACA,mBAAA;EJqIF;EIlIA;;IAEE,0BAAA;IACA,sBAAA;EJoIF;EIjIA;;;;IAIE,sBAAA;EJmIF;EIhIA;;IAEE,aAAA;IACA,QAAA;EJkIF;EIrIA;;IAMI,OAAA;IACA,gBAAA;IACA,oBAAA;EJmIJ;EI/HA;;IAEE,6BAAA;EJiIF;EI9HA;;;IAGE,6BAAA;EJgIF;EACA,cAAc;EI7Hd;IAEI,eAAA;EJ8HJ;EIhIA;IAMI,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,sBAAA;IACA,uBAAA;EJ6HJ;EIvIA;IAcI,eAAA;IACA,uBAAA;EJ4HJ;EI3IA;IAmBI,cAAA;IACA,kBAAA;EJ2HJ;EI/IA;;IAyBI,0BAAA;IACA,sBAAA;EJ0HJ;EIpJA;IA8BI,WAAA;EJyHJ;AACF;AAnfA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sNAAA;EACA,wCAAA;AAqfF;AAlfA;;;;EAIE,WAAA;EACA,YAAA;EACA,sBAAA;AAofF;AAjfA;;;;EAIE,aAAA;EACA,sBAAA;EACA,wBAAA;AAmfF","sourcesContent":["/*\n * @Author: Yoney Y (YuTianyuan)\n * @Date: 2021-12-10 13:44:27\n * @Last Modified by: undefined (ZhangZeHao)\n * @Last Modified time: 2022-04-27 10:50:38\n */\n\n@import url('./flex.less');\n@import url('./variable.less');\n@import url('./list-filter.less');\n@import url('./mobile.less');\n\n* {\n  margin                     : 0;\n  padding                    : 0;\n  list-style                 : none;\n  text-decoration            : none;\n  box-sizing                 : border-box;\n  font-family                : \"PingFangSC-Regular\", sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, apple color emoji, segoe ui emoji, Segoe UI Symbol, noto color emoji;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml,\nbody,\n#root,\n#App {\n  width           : 100%;\n  height          : 100%;\n  background-color: #fff;\n}\n\ninput,\ntextarea,\nbutton,\nvideo {\n  outline           : none;\n  vertical-align    : middle;\n  -webkit-appearance: none;\n}","\n// Flex 常用Css属性\n\n.flex {\n  display: flex;\n}\n\n.flex-shrink {\n  flex-shrink: 0;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-direction-row {\n  flex-direction: row;\n}\n\n.flex-direction-column {\n  flex-direction: column;\n}\n\n.flex-align-items-center {\n  align-items: center;\n}\n\n.flex-align-items-start {\n  align-items: flex-start;\n}\n\n.flex-align-items-end {\n  align-items: flex-end;\n}\n\n.flex-align-self-start {\n  align-self: flex-start;\n}\n\n.flex-align-self-end {\n  align-self: flex-end;\n}\n\n.flex-align-self-center {\n  align-self: center;\n}\n\n.flex-align-self-baseline {\n  align-self: baseline;\n}\n\n.flex-justify-content-center {\n  justify-content: center;\n}\n\n.flex-justify-content-start {\n  justify-content: flex-start;\n}\n\n.flex-justify-content-end {\n  justify-content: flex-end;\n}\n\n.flex-justify-content-space-between {\n  justify-content: space-between;\n}\n\n.flex-justify-content-space-around {\n  justify-content: space-around;\n}\n\n.flexLoop(@index) when(@index <=24) {\n  .flex-@{index} {\n    flex: @index\n  }\n\n  .flexLoop(@index + 1)\n}\n\n.flexLoop(1);\n\n// tools 工具Css属性\n\n// 单行溢出省略号\n.odd-overflow {\n  overflow     : hidden;\n  text-overflow: ellipsis;\n  white-space  : nowrap;\n}\n\n// 多行溢出省略号\n.more-overflow {\n  overflow             : hidden;\n  text-overflow        : ellipsis;\n  display              : -webkit-box;\n  -webkit-box-orient   : vertical;\n  // display: -moz-box;\n  // display: -moz-inline-box;\n  // display: -webkit-inline-box;\n  // -moz-box-orient: vertical;\n  // -webkit-line-clamp: 2;\n  // line-clamp: 2;\n}",":root {\n  --theme-main-color   : #3A7FFF;\n  --theme-comm-color   : #5B9DFF;\n  --theme-bg-color     : #F2F3F7;\n  --theme-main-bg-color: #FFFFFF;\n  --theme-text-color   : #000;\n  --theme-title-color  : #333;\n\n  --theme-active-color: #448FF7;\n  --theme-button-color: #448FF7;\n  --theme-primary-hover: #2F6FE6;\n  --theme-menu-bg: linear-gradient(180deg, #0a2f6e 0%, #1247a8 45%, #1a5fd0 100%);\n  --theme-menu-border: rgba(255, 255, 255, 0.08);\n  --theme-menu-text: rgba(255, 255, 255, 0.78);\n  --theme-menu-text-active: #ffffff;\n  --theme-menu-hover-bg: rgba(255, 255, 255, 0.14);\n  --theme-menu-active-bg: rgba(255, 255, 255, 0.22);\n  --theme-content-bg: #e9eef5;\n  --theme-content-surface: #ffffff;\n  --theme-content-border: #e4eaf2;\n  --theme-content-muted: #64748b;\n  --theme-filter-bg: linear-gradient(135deg, #dfeaff 0%, #ebf3ff 52%, #f5f9ff 100%);\n  --theme-filter-border: rgba(58, 127, 255, 0.28);\n  --theme-filter-accent: #3A7FFF;\n  --theme-shell-header-bg: linear-gradient(90deg, #0f2f6e 0%, #1d4ed8 52%, #2563eb 100%);\n\n  --theme-padding: 20px;\n}\n","/* 列表页 / 弹窗内搜索区统一样式 */\n#Home .znrunpay-home-content .list-filter,\n.ant-modal .list-filter,\n.list-filter {\n  padding: 18px 18px 6px;\n  background: var(--theme-filter-bg);\n  border: 1px solid var(--theme-filter-border);\n  border-left: 4px solid var(--theme-filter-accent);\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(58, 127, 255, 0.1);\n\n  .ant-form-item-label > label {\n    color: #475569;\n    font-weight: 500;\n  }\n}\n\n#Home .znrunpay-home-content .list-filter {\n  margin: 16px 16px 0;\n}\n\n.ant-modal .list-filter {\n  margin-bottom: 16px;\n}\n","/* 后台管理手机端适配：侧栏抽屉、弹窗铺满、表格横滑、表单竖排 */\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n}\n\n@media (max-width: 767px) {\n  input,\n  textarea,\n  select,\n  .ant-input,\n  .ant-input-affix-wrapper,\n  .ant-select-selector,\n  .ant-picker {\n    font-size: 16px !important;\n  }\n\n  /* —— 布局：内容占满，侧栏改抽屉 —— */\n  #Home {\n    display: flex;\n    flex-direction: column;\n\n    .znrunpay-home-header-wrap {\n      position: relative;\n      z-index: 1300;\n      flex-shrink: 0;\n    }\n\n    .znrunpay-home-main {\n      flex: 1;\n      min-height: 0;\n      height: auto !important;\n      width: 100%;\n    }\n\n    .znrunpay-home-layout-left {\n      position: fixed;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: min(82vw, 300px) !important;\n      padding-top: 52px;\n      z-index: 1200;\n      overflow: auto;\n    }\n\n    .znrunpay-home-layout-right,\n    .layout-menu-show,\n    .layout-right-hidden {\n      width: 100% !important;\n      padding: 6px 6px 0;\n    }\n\n    .znrunpay-home-content {\n      height: 100%;\n      border-radius: 8px 8px 0 0;\n\n      .ant-layout {\n        padding: 8px 10px !important;\n      }\n\n      .list-table {\n        margin: 8px 6px 12px;\n        padding: 8px;\n        overflow-x: auto;\n      }\n    }\n  }\n\n  .znrunpay-menu-mask {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.48);\n    z-index: 1100;\n  }\n\n  .znrunpay-menu {\n    height: calc(100vh - 60px);\n\n    .znrun-menu-item {\n      min-height: 44px;\n      padding: 12px;\n    }\n\n    .znrunpay-menu-right-con {\n      min-height: 40px;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  /* —— 顶栏 —— */\n  .znrunpay-home-header {\n    height: 52px;\n    padding: 0 6px;\n    gap: 6px;\n\n    .znrunpay-header-left {\n      min-width: 0;\n      padding: 0 4px;\n\n      .znrunpay-brand-title {\n        font-size: 16px;\n        max-width: 88px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .menu-button {\n      padding: 0 !important;\n      min-width: 44px;\n      min-height: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .znrunpay-header-missing-track {\n      min-width: 0;\n      max-width: none;\n      margin: 0 4px;\n      padding: 4px 8px;\n      gap: 6px;\n\n      .znrunpay-header-missing-track-text {\n        display: none;\n      }\n    }\n\n    .znrunpay-header-layout-right {\n      .znrunpay-account-switch {\n        margin-right: 6px;\n\n        .ant-select {\n          width: 112px !important;\n        }\n      }\n\n      .znrunpay-user-profile {\n        margin: 0 0 0 4px;\n        padding: 2px 6px;\n\n        .znrunpay-user-profile-name {\n          display: none;\n        }\n      }\n\n      .znrunpay-user-down {\n        display: none;\n      }\n    }\n  }\n\n  .znrunpay-impersonate-banner-inner {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  /* —— 筛选区：标签在上、控件铺满 —— */\n  .list-filter {\n    padding: 12px 12px 2px !important;\n    margin: 8px 6px 0 !important;\n\n    .ant-form-item {\n      margin-bottom: 10px;\n    }\n\n    .ant-form-item .ant-form-item-row {\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    .ant-form-item-label {\n      text-align: left !important;\n      padding: 0 0 4px !important;\n      max-width: 100% !important;\n      width: 100% !important;\n\n      > label {\n        height: auto;\n      }\n    }\n\n    .ant-form-item-control {\n      max-width: 100% !important;\n      width: 100% !important;\n    }\n\n    .znrunpay-order-search .ant-form-item-control-input-content {\n      display: flex;\n      gap: 8px;\n\n      .ant-btn {\n        flex: 1;\n        height: 40px;\n      }\n    }\n  }\n\n  .znrunpay-total-button {\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .znrunpay-table-setup {\n      margin-left: 0;\n      width: 100%;\n\n      .ant-space {\n        width: 100%;\n        flex-wrap: wrap;\n      }\n\n      .ant-btn {\n        min-height: 40px;\n      }\n    }\n  }\n\n  /* —— 表格：横滑 + 更大点击区域 —— */\n  .ant-table-wrapper,\n  .ant-table-content,\n  .ant-table-container {\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ant-table {\n    min-width: 640px;\n\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      padding: 8px 10px !important;\n      white-space: nowrap;\n    }\n\n    .ant-table col:last-child {\n      width: 96px !important;\n    }\n\n    .ant-table-thead > tr > th:last-child,\n    .ant-table-tbody > tr > td:last-child {\n      position: sticky;\n      right: 0;\n      z-index: 3;\n      background: #fff;\n      white-space: normal !important;\n      box-shadow: -6px 0 10px rgba(15, 23, 42, 0.08);\n    }\n\n    .ant-table-tbody > tr > td:has(.ant-btn) {\n      white-space: normal;\n    }\n\n    .ant-btn-link {\n      min-height: 36px;\n      padding: 6px 8px !important;\n      font-size: 14px;\n    }\n\n    .ant-space {\n      flex-wrap: wrap;\n    }\n  }\n\n  .ant-pagination {\n    flex-wrap: wrap !important;\n    justify-content: flex-start !important;\n    row-gap: 8px;\n\n    .ant-pagination-options-quick-jumper {\n      display: none;\n    }\n  }\n\n  /* —— 弹窗：铺满可视区域，表单竖排 —— */\n  .ant-modal {\n    max-width: calc(100vw - 12px) !important;\n    width: calc(100vw - 12px) !important;\n    margin: 8px auto !important;\n    padding-bottom: 0;\n    top: 8px !important;\n  }\n\n  .ant-modal-centered .ant-modal {\n    top: 0 !important;\n  }\n\n  .ant-modal-content {\n    max-height: calc(100vh - 16px);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ant-modal-body {\n    overflow-y: auto;\n    max-height: calc(100vh - 150px);\n    padding: 12px !important;\n  }\n\n  .ant-modal .ant-col,\n  .znrunpay-Distribution-confirm .ant-col {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n    margin-inline-start: 0 !important;\n  }\n\n  .ant-modal .ant-form-item .ant-form-item-row,\n  .znrunpay-Distribution-confirm .ant-form-item .ant-form-item-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ant-modal .ant-form-item-label,\n  .znrunpay-Distribution-confirm .ant-form-item-label {\n    text-align: left !important;\n    max-width: 100% !important;\n    width: 100% !important;\n    padding-bottom: 4px;\n  }\n\n  .ant-modal .ant-form-item-control,\n  .znrunpay-Distribution-confirm .ant-form-item-control {\n    max-width: 100% !important;\n    width: 100% !important;\n  }\n\n  .ant-modal .ant-select,\n  .ant-modal .ant-picker,\n  .znrunpay-Distribution-confirm .ant-select,\n  .znrunpay-Distribution-confirm .ant-picker {\n    width: 100% !important;\n  }\n\n  .ant-modal-confirm-btns,\n  .ant-modal-footer {\n    display: flex;\n    gap: 8px;\n\n    .ant-btn {\n      flex: 1;\n      min-height: 40px;\n      margin: 0 !important;\n    }\n  }\n\n  .ant-popover,\n  .ant-popconfirm {\n    max-width: calc(100vw - 24px);\n  }\n\n  .ant-select-dropdown,\n  .ant-picker-dropdown,\n  .ant-dropdown {\n    max-width: calc(100vw - 12px);\n  }\n\n  /* —— 登录页 —— */\n  #Login {\n    .znrunpay-login-right {\n      max-width: 100%;\n    }\n\n    .znrunpay-login-form-content {\n      position: relative !important;\n      top: auto !important;\n      left: auto !important;\n      width: 100% !important;\n      padding: 48px 20px 24px;\n    }\n\n    .znrunpay-login-logo {\n      padding-left: 0;\n      justify-content: center;\n    }\n\n    .znrunpay-right-text {\n      margin-left: 0;\n      text-align: center;\n    }\n\n    .ant-form-item-control,\n    .ant-form-item-label {\n      max-width: 100% !important;\n      width: 100% !important;\n    }\n\n    .znrunpay-right-from-input {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
